module.exports = __webpack_public_path__ + "resources/img/main02_m.16a1b369a07bf2eadc6b2e9008b6ddc2.png";